var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        .st0{fill:#fff}.st5{fill:#e6e6e5}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0 0h100v100H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100H0V0h100v100zM9.7 90h80.7V10H9.7",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1072ba",
    d: "M30.1 73l-4.3-49.5h48.4L69.9 73 50 78.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2aaae2",
    d: "M50 74.3l16.1-4.4 3.7-42.3H50z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b4b4b4",
    d: "M35.9 45.8l.5 6.1L50 45.8v-6.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.2 33.2L50 39.7v6.1l14.6-6.5zM50 61.7l-6.8-1.9-.4-4.8h-6.1l.8 9.5L50 68z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50 45.8v6.1h7.5l-.7 7.9-6.8 1.9V68l12.4-3.5 1.7-18.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50 45.8H35.9l.5 6.1H50zm0-6.5v-6.1H34.8l.5 6.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50 33.2v6.1h14.6l.6-6.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.81256207.svg";
export { ForwardRef as ReactComponent };